import React from 'react';
import {IconProps} from './types';

const LockOutline = ({
    fill = 'currentColor',
    className,
    width = 20,
    height = 20,
}: IconProps) => {
    const clipPathId = React.useId().replace(/:/g, '_');
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            className={className}
        >
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M8.33325 13.3583C8.33325 13.8004 8.50885 14.2243 8.82141 14.5368C9.13397 14.8494 9.55789 15.025 9.99992 15.025C10.4419 15.025 10.8659 14.8494 11.1784 14.5368C11.491 14.2243 11.6666 13.8004 11.6666 13.3583C11.6666 12.9163 11.491 12.4924 11.1784 12.1798C10.8659 11.8673 10.4419 11.6917 9.99992 11.6917C9.55789 11.6917 9.13397 11.8673 8.82141 12.1798C8.50885 12.4924 8.33325 12.9163 8.33325 13.3583Z"
                    stroke={fill}
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.0834 11.275C17.0834 10.3909 16.7322 9.5431 16.1071 8.91798C15.482 8.29285 14.6341 7.94167 13.7501 7.94167H6.25008C5.36603 7.94167 4.51818 8.29285 3.89306 8.91798C3.26794 9.5431 2.91675 10.3909 2.91675 11.275V16.275C2.91675 17.1591 3.26794 18.0069 3.89306 18.632C4.51818 19.2571 5.36603 19.6083 6.25008 19.6083H13.7501C14.6341 19.6083 15.482 19.2571 16.1071 18.632C16.7322 18.0069 17.0834 17.1591 17.0834 16.275V11.275Z"
                    stroke={fill}
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.41675 8.04667V5.025C5.41675 3.80942 5.89963 2.64363 6.75918 1.78409C7.61872 0.924551 8.78451 0.441666 10.0001 0.441666C11.2157 0.441666 12.3814 0.924551 13.241 1.78409C14.1005 2.64363 14.5834 3.80942 14.5834 5.025V8.04667"
                    stroke={fill}
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LockOutline;
